import { render, staticRenderFns } from "./CenterBox.vue?vue&type=template&id=56f249ce&scoped=true&"
import script from "./CenterBox.vue?vue&type=script&lang=js&"
export * from "./CenterBox.vue?vue&type=script&lang=js&"
import style0 from "./CenterBox.vue?vue&type=style&index=0&id=56f249ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f249ce",
  null
  
)

export default component.exports